<article class="fact-card">
  <div class="fact-card__header">
    <div class="fact-card__hero">
      <app-daily-fact-hero [hero]="fact().hero" />
    </div>
    <div class="fact-card__meta">
      <span class="fact-card__date">{{ fact().date }}</span>
      <span class="category-badge">{{ fact().category || '-' }}</span>
    </div>
    <app-daily-fact-status-badge
      [status]="fact().videoStatus"
      [label]="getVideoStatusLabel()(fact().videoStatus)"
      [statusClass]="getVideoStatusClass()(fact().videoStatus)"
    />
  </div>
  <p class="fact-card__fact">{{ fact().fact }}</p>
  <div class="fact-card__actions">
    <app-daily-fact-actions
      [fact]="fact()"
      [isGenerating]="isGenerating()(fact().id)"
      [canReview]="canReviewVideo()(fact())"
      (generate)="generateVideo.emit($event)"
      (review)="reviewVideo.emit($event)"
    />
  </div>
</article>
